// extracted by mini-css-extract-plugin
export var barContainer = "_ay-0";
export var fillBar = "_ay-5";
export var fillContainer = "_ay-3";
export var overflow = "_ay-7";
export var overflowContainer = "_ay-4";
export var regular = "_ay-6";
export var thick = "_ay-1";
export var thin = "_ay-2";